

























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
})
export default class ErrorWrappedTextInput extends Vue {
  @Prop(String) label: string;
  @Prop(String) placeholder: string;
  @Prop(String) value: string;
  @Prop(String) error: string;
  @Prop(String) maxlength: string;
  @Prop(Boolean) autofocus?: boolean;

  hasErrors = false;

  myValue: string = '';

  created() {
    this.myValue = this.value;
  }

  @Watch('error')
  divClasses() {
    this.hasErrors = !!this.error;
  }

  onInput(e:any) {
    this.$emit('input', e.target.value);
  }

  onChange(e:any) {
    this.$emit('change', e.target.value);
  }
}
